<template>
    <div id="share">
        <img src="../assets/image/share.png" alt="" class="share-img">
        <!--        第一个-->
        <div class="header">
            <div class="header-box">
                <div class="share-title">
                    <img src="../assets/image/2.png" alt="">
                    <span>赚钱涨粉真的很简单</span>
                    <img src="../assets/image/2.png" alt="">
                </div>
                <div class="share-content">
                    <div class="share-content-top">
                        <img src="../assets/image/3.png" alt="">
                    </div>
                    <div class="share-content-bottom">
                        <div class="text">一部手机</div>
                        <div class="text">秒火APP</div>
                        <div class="text">赚钱、涨粉</div>
                    </div>
                </div>
            </div>
        </div>
        <!--        第二个-->
        <div class="share-box two-header">
            <div class="share-title">
                <img src="../assets/image/2.png" alt="">
                <span>涨粉优势</span>
                <img src="../assets/image/2.png" alt="">
            </div>
            <div class="share-box-content">
                <div class="share-box-content-item">
                    <img src="../assets/image/1-1.png" alt="">
                    <div class="text">自有百万粉丝流量池，发布任务
                        即刻导流涨粉。
                    </div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/1-2.png" alt="">
                    <div class="text">全网首家垂直于视频号、抖音、快
                        手的短视频内容涨粉工具平台。
                    </div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/1-3.png" alt="">
                    <div class="text">支持关注、点赞、评论、转发到
                        朋友圈以及直播预约点赞转发等
                        多业务模式。
                    </div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/1-4.png" alt="">
                    <div class="text">平台担保真人真粉，杜绝僵尸粉</div>
                </div>
            </div>
        </div>
        <div class="share-box three-header">
            <div class="share-title">
                <img src="../assets/image/2.png" alt="">
                <span>赚钱优势</span>
                <img src="../assets/image/2.png" alt="">
            </div>
            <div class="share-box-content">
                <div class="share-box-content-item">
                    <img src="../assets/image/2-1.png" alt="">
                    <div class="text">操作简单</div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/2-2.png" alt="">
                    <div class="text">无需交纳费用</div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/2-3.png" alt="">
                    <div class="text">无提现门槛</div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/2-4.png" alt="">
                    <div class="text">他人赚钱你分钱</div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/2-5.png" alt="">
                    <div class="text">极速打款</div>
                </div>
                <div class="share-box-content-item">
                    <img src="../assets/image/2-6.png" alt="">
                    <div class="text">官方保障</div>
                </div>
            </div>
        </div>
        <div class="share-box four-header">
            <div class="share-title">
                <img src="../assets/image/2.png" alt="">
                <span>更多功能</span>
                <img src="../assets/image/2.png" alt="">
            </div>
            <div class="share-box-content">
                <div class="share-box-item">
                    <img src="../assets/image/3-1.png" alt="" class="left-icon">
                    <div class="item-right">
                        <div class="item-right-title">万能提词器</div>
                        <div class="item-right-text">任何美颜相机都可拍摄提词，
                            拍摄直播再也不用背台词。
                        </div>
                    </div>
                </div>
                <div class="share-box-item">
                    <img src="../assets/image/3-2.png" alt="" class="left-icon">
                    <div class="item-right">
                        <div class="item-right-title">视频提取文案</div>
                        <div class="item-right-text">别人的文案秒变自己文案，正
                            确率高达98%。
                        </div>
                    </div>
                </div>
                <div class="share-box-item">
                    <img src="../assets/image/3-3.png" alt="" class="left-icon">
                    <div class="item-right">
                        <div class="item-right-title">去水印</div>
                        <div class="item-right-text">全网短视频任意去除水印，再 也不缺视频素材。</div>
                    </div>
                </div>
                <div class="share-box-item">
                    <img src="../assets/image/3-4.png" alt="" class="left-icon">
                    <div class="item-right">
                        <div class="item-right-title">精品剧本</div>
                        <div class="item-right-text">上万条精品剧本，想拍哪条就
                            拍哪条。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="download" :style="{'top':top+'px'}">
            <div class="download-android">
                <img src="../assets/image/logo.png" alt="">
                <span v-show="isAndroid">秒火安卓版</span>
                <span v-show="isIOS">秒火IOS版</span>
            </div>
            <div class="download-btn" @click="downApp">下载APP</div>
        </div>
    </div>
</template>

<script>
  import qs from 'qs'

  export default {
    name: 'Home',
    metaInfo: {
      title: '秒火', // set a title
    },
    data() {
      return {
        advantageData: [],
        inviteCode: '',
        avatar: '',
        code: '',
        isAndroid: '',
        isIOS: '',
        uid: '',
        top: 110,
      }
    },
    created() {
      this.code = this.GetUrlParam('code');
      if (this.getUrl().inviteCode) {
        this.inviteCode = this.getUrl().inviteCode;
      } else {
        this.inviteCode = '';
      }

      console.log(this.inviteCode);
      console.log(this.code);
      if (!this.code) {
        var local = window.location.href;
        let wx_appid = 'wx7f18b5a11b78e495';
        window.location.href = " https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + wx_appid + "&redirect_uri=" + encodeURIComponent(local) + "&response_type=code&scope=snsapi_userinfo&state=1,0#wechat_redirect"
      } else {
        //把code传给后台获取用户信息
        this.getLogin()
      }
      var u = window.navigator.userAgent;
      this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //安卓
      this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        let b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        console.log(b);
        if (b > 100) {
          this.top = 0;
        } else {
          this.top = 110;
        }
      },
      // 登录
      getLogin() {
        let obj = this.$getSIgn({code: this.code});
        let key = obj.key;
        let cliplabSign = obj.cliplabSign;
        this.$axios({
          url: `/user/mpLogin`,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cliplab-sign': cliplabSign,
            'cliplab-origin': 'h5',
            'cliplab-key': key,
          },
          method: 'post',
          params: {
            code: this.code,
          }
        }).then((res) => {
          if (res.data.res == 0) {
            let data = res.data.data;
            this.uid = data.uid;
            localStorage.setItem('uid', data.uid);
            let time1 = new Date().getTime();
            let time2 = new Date(data.createTime).getTime();
            console.log(time1, time2);
            if (this.date(time1, time2) < 3) {
              if (!data.inviteCodePrev) {
                this.getBind();
              }
            }
          }
        });
      },
      // 绑定用户
      getBind() {
        let obj = this.$getSIgn({inviteCode: this.inviteCode});
        let key = obj.key;
        let cliplabSign = obj.cliplabSign;
        this.$axios({
          url: `/user/bindUserInviteCode`,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cliplab-sign': cliplabSign,
            'cliplab-origin': 'h5',
            'cliplab-key': key,
            'cliplab-uid': this.encrypt(this.uid)
          },
          method: 'post',
          data: qs.stringify({
            inviteCode: this.inviteCode
          })
        }).then((res) => {
          console.log(res.data.res);
        });
      },
      playVideo() {
        this.$router.push('/videoPlay')
      },
      copy() {
        let oInput = document.createElement('input');
        oInput.value = this.inviteCode;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        console.log(oInput.value);
        document.execCommand("Copy"); // 执行浏览器复制命令
        alert("复制成功");
        oInput.remove()
      },
      // 正常模式获取参数
      GetUrlParam(name) {//封装方法
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg); //匹配目标参数
        if (r != null) return unescape(r[2]);
        return null; //返回参数值
      },
      //哈希模式下获取参数
      getUrl() {
        let url = window.location.href;
        url = decodeURIComponent(url.substring(url.lastIndexOf("?") + 1));
        let index;
        if ((index = url.indexOf("#")) > 0)
          url = url.substring(0, index);
        let params = {};
        url.split("&").forEach(v => {
          let index;
          if ((index = v.indexOf("=")) > 0) {
            params[v.substring(0, index)] = v.substring(index + 1);
          }
        });
        return params;
      },
      downApp() {
        if (this.isIOS) {
          window.location.href = 'https://itunes.apple.com/cn/app/id1565128575?mt=8'
        }
        if (this.isAndroid) {
          window.location.href = 'https://cliplab.jianyingkeji.net/android/cliplab1.0.0.apk'
        }
      },
      // 乘法
      accMul(arg1, arg2) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
          m += s1.split(".")[1].length
        } catch (e) {
        }
        try {
          m += s2.split(".")[1].length
        } catch (e) {
        }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
      },
      date(start_time, end_time) {
        var usedTime = start_time - end_time;  //两个时间戳相差的毫秒数
        var days = Math.floor(usedTime / (24 * 3600 * 1000));//相差的天数
        var leave1 = usedTime % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数
        var hours = Math.floor(leave1 / (3600 * 1000));   //计算出小时数
        var leave2 = leave1 % (3600 * 1000);        //计算小时数后剩余的毫秒数
        var minutes = Math.floor(leave2 / (60 * 1000));//计算相差分钟数
        var leave3 = leave2 % (60 * 1000); //计算分钟后剩下的毫秒数
        var s = Math.floor(leave3 / 1000);   //计算相差秒数
        return (days * 24 * 60) + (hours * 60) + minutes;
      },
    },
  }
</script>
<style scoped lang="less">
    #share {
        /*优势*/
        background: #F34A4A;
        padding-bottom: 65px;

        .share-img {
            width: 100%;
        }

        .header {
            width: 750px;
            height: 1369px;
            background: url('../assets/image/1.png');
            background-size: 100% 100%;
            position: relative;

            .header-box {
                position: absolute;
                top: 964px;
                left: 38px;
                width: 654px;
                height: 362px;
                border-radius: 24px;

                .share-title {
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 527px;
                    height: 75px;
                    background: linear-gradient(0deg, #FF5723 0%, #FF0013 100%);
                    box-shadow: 0px 5px 38px 0px rgba(255, 15, 35, 0.23);
                    border-radius: 12px;
                    font-size: 40px;
                    font-weight: normal;
                    color: #FFF9EF;
                    line-height: 75px;
                    text-align: center;

                    img {
                        width: 34px;
                        height: 34px;
                        margin: 0 10px;
                    }
                }

                .share-content {
                    padding-top: 118px;

                    .share-content-top {
                        width: 100%;
                        text-align: center;

                        img {
                            width: 533px;
                            height: 106px;
                        }
                    }

                    .share-content-bottom {
                        margin: 0 auto;
                        width: 550px;
                        display: flex;
                        justify-content: space-between;
                        font-size: 28px;
                        font-weight: normal;
                        color: #4A3D3E;
                        line-height: 36px;
                        padding-top: 10px;
                    }
                }
            }
        }

        .share-box {
            width: 654px;
            background: #FFF9EF;
            border-radius: 24px;
            margin: 104px auto 0 auto;
            position: relative;

            .share-title {
                position: absolute;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 388px;
                height: 75px;
                background: linear-gradient(0deg, #FF5723 0%, #FF0013 100%);
                box-shadow: 0px 5px 38px 0px rgba(255, 15, 35, 0.23);
                border-radius: 12px;
                font-size: 40px;
                font-weight: normal;
                color: #FFF9EF;
                line-height: 75px;
                text-align: center;

                img {
                    width: 34px;
                    height: 34px;
                    margin: 0 10px;
                }
            }
        }

        .two-header {
            height: 870px;
            margin-top: 58px;

            .share-box-content {
                padding-top: 40px;
                box-sizing: border-box;

                .share-box-content-item {
                    display: flex;
                    width: 561px;
                    background: rgba(255, 237, 212, 0.6);
                    border-radius: 10px;
                    margin: 32px auto 0 auto;
                    padding: 28px 20px;

                    img {
                        width: 45px;
                        height: 45px;
                    }

                    .text {
                        font-size: 30px;
                        font-weight: bold;
                        color: #4A3D3E;
                        line-height: 55px;
                        margin-left: 34px;
                    }
                }
            }

        }

        .three-header {
            height: 565px;

            .share-box-content {
                display: flex;
                flex-wrap: wrap;
                padding-top: 120px;
                box-sizing: border-box;

                .share-box-content-item {
                    width: 33.3%;
                    text-align: center;
                    margin-bottom: 52px;

                    img {
                        width: 104px;
                        height: 105px;
                    }

                    .text {
                        font-size: 24px;
                        font-weight: 400;
                        color: #DC122A;
                        line-height: 31px;
                    }
                }
            }
        }

        .four-header {
            height: 889px;

            .share-box-content {
                padding: 90px 30px 10px 43px;
                box-sizing: border-box;

                .share-box-item {
                    display: flex;
                    margin-bottom: 55px;

                    .left-icon {
                        width: 123px;
                        height: 123px;
                    }

                    .item-right {
                        margin-left: 49px;

                        .item-right-title {
                            font-size: 38px;
                            font-weight: 900;
                            color: #333333;
                            line-height: 33px;
                            padding-bottom: 20px;
                        }

                        .item-right-text {
                            font-size: 31px;
                            font-weight: 400;
                            color: #999999;
                            line-height: 46px;
                        }
                    }
                }
            }
        }

        .download {
            width: 722px;
            height: 112px;
            background: #FFFFFF;
            position: fixed;
            left: 14px;
            display: flex;
            padding-left: 16px;
            padding-right: 18px;
            box-sizing: border-box;
            justify-content: space-between;
            align-items: center;

            .download-android {
                font-size: 30px;
                font-weight: bold;
                color: #040404;
                display: flex;
                align-items: center;

                img {
                    width: 82px;
                    height: 82px;
                    margin-right: 20px;
                }
            }

            .download-btn {
                width: 203px;
                height: 62px;
                background: #EB152E;
                border-radius: 31px;
                font-size: 30px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 62px;
                text-align: center;
            }
        }
    }
</style>
